import React, { useEffect, Fragment } from 'react';
import {
    changeColorAll,
    changeDepartment1All,
    changeDepartment2All,
    changeAddressAll,
    changeAddress2All,
    changeSuiteRoomAll,
} from './../CanvasActions';
import TextField from './../Form/TextField';
import SelectField from './../Form/SelectField';

const FormP11 = React.memo((props) => {
    useEffect(() => {
        changeColorAll(props.color);
    }, [props.color]);

    useEffect(() => {
        changeDepartment1All(props.department1);
    }, [props.department1]);

    useEffect(() => {
        changeDepartment2All(props.department2);
    }, [props.department2]);

    useEffect(() => {
        changeAddressAll(props.address);
    }, [props.address]);

    useEffect(() => {
        changeAddress2All(props.address2);
    }, [props.address2]);

    useEffect(() => {
        changeSuiteRoomAll(props.suiteRoom);
    }, [props.suiteRoom]);

    let title = '';
    if (props.templateCode === 'p11t1') {
        title = 'UTHealth Houston | Cizik School of Nursing #10 Envelopes';
    } else if (props.templateCode === 'p11t2') {
        title = 'UTHealth Houston | McGovern Medical School #10 Envelopes';
    } else if (props.templateCode === 'p11t3') {
        title = 'MD Anderson Cancer Center | UTHealth Houston Graduate School #10 Envelopes';
    } else if (props.templateCode === 'p11t4') {
        title = 'UTHealth Houston | School of Dentistry #10 Envelopes';
    } else if (props.templateCode === 'p11t5') {
        title = 'UTHealth | School of Public Health #10 Envelopes';
    } else if (props.templateCode === 'p11t6') {
        title = 'UTHealth Houston | School of Biomedical Informatics #10 Envelopes';
    } else if (props.templateCode === 'p11t7') {
        title = 'UTHealth Houston | General #10 Envelopes';
    } else if (props.templateCode === 'p11t8') {
        title = 'MD Anderson Cancer Center UTHealth Graduate School A10 Envelope';
    } else if (props.templateCode === 'p11t9') {
        title = 'UTHealth Cizik School of Nursing A10 Envelope';
    } else if (props.templateCode === 'p11t10') {
        title = 'UTHealth General Administration A10 Envelope';
    } else if (props.templateCode === 'p11t11') {
        title = 'UTHealth McGovern Medical School A10 Envelope';
    } else if (props.templateCode === 'p11t12') {
        title = 'UTHealth School of Biomedical Informatics A10 Envelope';
    } else if (props.templateCode === 'p11t13') {
        title = 'UTHealth School of Dentistry A10 Envelope';
    } else if (props.templateCode === 'p11t14') {
        title = 'UTHealth School of Public Health A10 Envelope';
    } else if (props.templateCode === 'p11t15') {
        title = 'Cizik School of Nursing A6 Envelope';
    } else if (props.templateCode === 'p11t16') {
        title = 'McGovern Medical School A6 Envelope';
    } else if (props.templateCode === 'p11t17') {
        title = 'MD Anderson Cancer Center UTHealth Graduate School A6 Envelope';
    } else if (props.templateCode === 'p11t18') {
        title = 'School of Biomedical Informatics A6 Envelope';
    } else if (props.templateCode === 'p11t19') {
        title = 'School of Dentistry A6 Envelope';
    } else if (props.templateCode === 'p11t20') {
        title = 'School of Public Health A6 Envelope';
    } else if (props.templateCode === 'p11t21') {
        title = 'UTHealth General Administration A6 Envelope';
    } else if (props.templateCode === 'p11t22') {
        title = 'UTHealth Houston | McWilliams School of Biomedical Informatics #10 Envelopes';
    } else if (props.templateCode === 'p11t23') {
        title = 'UTHealth Houston | School of Public Health #10 Envelopes';
    } else if (props.templateCode === 'p11t25') {
        title = 'UTHealth Houston | UTHealth Behavioral Sciences #10 Envelopes';
    }

    let optionalLine1Field = (
        <Fragment>
            <div className="subtitle">Optional Line 1:</div>
            <TextField
                label="Office, Center, Department, Institute, Program"
                value={props.department1}
                setFunction={props.setDepartment1}
                placeholder="Example: Institute for Stroke and Cerebrovascular Diseases"
            />
        </Fragment>
    );
    let optionalLine2Field = (
        <Fragment>
            <div className="subtitle">Optional Line 2:</div>
            <TextField
                label="Office, Center, Department, Institute, Program"
                value={props.department2}
                setFunction={props.setDepartment2}
                placeholder="Optional second line"
            />
        </Fragment>
    );
    let suiteRoomField = (
        <TextField
            required
            label="Address"
            value={props.suiteRoom}
            setFunction={props.setSuiteRoom}
            placeholder="Example: MDA 2SCR4.2016 (Unit 0900)"
        />
    );
    let quantityField = (
        <SelectField
            required
            label="Quantity"
            value={props.quantity}
            setFunction={props.setQuantity}
            options={[
                { value: '', label: 'Select option' },
                { value: '250', label: '250' },
                { value: '500', label: '500' },
                { value: '1000', label: '1000' },
            ]}
        />
    );
    let description = (
        <Fragment>
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> {title}</div>
                <div className="description-list">
                    <span className="label">Description:</span>
                    <ul>
                        <li>Flat: #10 Business envelope</li>
                        <li>Stock: 100# Opaque White Cover</li>
                        <li>Printed: One Side</li>
                    </ul>
                </div>
            </div>
        </Fragment>
    );
    let address1Field = (
        <TextField
            required
            label="Address"
            value={props.address}
            setFunction={props.setAddress}
            placeholder="Example: 6431 Fannin Street, Suite 1880"
        />
    );
    let address2Field = (
        <TextField
            required
            label="City, State, Zip"
            value={props.address2}
            setFunction={props.setAddress2}
            placeholder="Example: Houston, Texas 77030"
        />
    );
    let windowField = (
        <SelectField
            required
            label="Window Envelope"
            value={props.window}
            setFunction={props.setWindow}
            options={[
                { value: 1, label: 'Yes' },
                { value: 0, label: 'No' },
            ]}
        />
    );

    if (['p11t1', 'p11t2', 'p11t4', 'p11t6'].includes(props.templateCode)) {
        return (
            <form action="" className="envelopes-fields">
                <hr />
                {optionalLine1Field}
                <hr />
                {optionalLine2Field}
                <hr />
                {suiteRoomField}
                {address2Field}
                <hr />
                {windowField}
                <hr />
                {quantityField}
                <hr />
                {description}
            </form>
        );
    } else if (['p11t3'].includes(props.templateCode)) {
        return (
            <form action="" className="envelopes-fields">
                <hr />
                {optionalLine1Field}
                <hr />
                {suiteRoomField}
                {address2Field}
                <hr />
                {windowField}
                <hr />
                {quantityField}
                <hr />
                {description}
            </form>
        );
    } else if (['p11t7'].includes(props.templateCode)) {
        return (
            <form action="" className="envelopes-fields">
                <hr />
                {optionalLine1Field}
                <hr />
                {suiteRoomField}
                {address2Field}
                <hr />
                {windowField}
                <hr />
                {quantityField}
                <hr />
                {description}
            </form>
        );
    } else if (['p11t5'].includes(props.templateCode)) {
        return (
            <form action="" className="envelopes-fields">
                <hr />
                {optionalLine1Field}
                <hr />
                {optionalLine2Field}
                <hr />
                {address1Field}
                {address2Field}
                <hr />
                {windowField}
                <hr />
                {quantityField}
                <hr />
                {description}
            </form>
        );
    }

    return null;
});

export default FormP11;
